import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { egiRoutes } from '@/app/egi.pages/routes';
import { AppRootPagesModule } from '@/app/egi.pages/app-root.pages/app-root.pages.module';
import { ExternalPagesModule } from '@/app/egi.pages/external.pages/external.pages.module';
import { PlatformManagementPagesModule } from '@/app/egi.pages/platform-management.pages/platform-management.pages.module';
import { ExamplePagesModule } from '@/app/egi.pages/example.pages/example.pages.module';
import { HdPagesModule } from '@/app/egi.pages/human-design/chart.pages/hd.pages.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    AppRootPagesModule,
    ExternalPagesModule,
    PlatformManagementPagesModule,
    ExamplePagesModule,
    HdPagesModule
  ]
})
export class EgiPagesModule {
  public static readonly routes = egiRoutes;
}
